import { render, staticRenderFns } from "./AllocateToOtherState.vue?vue&type=template&id=0e38ec8e"
import script from "./AllocateToOtherState.vue?vue&type=script&lang=js"
export * from "./AllocateToOtherState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports